// Helper function to shuffle array
const shuffleArray = (array) => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

// Base mugshot data
const baseMugshots = [
  {
    id: '1',
    name: 'John Smith',
    age: 34,
    imageUrl: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop',
    correctCharge: 'Theft',
    possibleOptions: ['Theft', 'Assault', 'DUI', 'Vandalism', 'Shoplifting', 'Burglary']
  },
  {
    id: '2',
    name: 'Sarah Johnson',
    age: 28,
    imageUrl: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop',
    correctCharge: 'Fraud',
    possibleOptions: ['Fraud', 'Shoplifting', 'Trespassing', 'Disorderly Conduct', 'Forgery', 'Identity Theft']
  },
  {
    id: '3',
    name: 'Michael Brown',
    age: 42,
    imageUrl: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop',
    correctCharge: 'DUI',
    possibleOptions: ['DUI', 'Reckless Driving', 'Hit and Run', 'Speeding', 'Public Intoxication', 'Disorderly Conduct']
  },
  {
    id: '4',
    name: 'Emily Davis',
    age: 31,
    imageUrl: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop',
    correctCharge: 'Shoplifting',
    possibleOptions: ['Shoplifting', 'Burglary', 'Theft', 'Robbery', 'Vandalism', 'Trespassing']
  },
  {
    id: '5',
    name: 'David Wilson',
    age: 39,
    imageUrl: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop',
    correctCharge: 'Assault',
    possibleOptions: ['Assault', 'Battery', 'Domestic Violence', 'Fighting', 'Disorderly Conduct', 'Resisting Arrest']
  },
  {
    id: '6',
    name: 'Jessica Martinez',
    age: 26,
    imageUrl: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=400&fit=crop',
    correctCharge: 'Vandalism',
    possibleOptions: ['Vandalism', 'Graffiti', 'Property Damage', 'Trespassing', 'Disorderly Conduct', 'Criminal Mischief']
  },
  {
    id: '7',
    name: 'Robert Garcia',
    age: 45,
    imageUrl: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=400&fit=crop',
    correctCharge: 'Forgery',
    possibleOptions: ['Forgery', 'Fraud', 'Identity Theft', 'Counterfeiting', 'Embezzlement', 'Wire Fraud']
  },
  {
    id: '8',
    name: 'Amanda Lee',
    age: 33,
    imageUrl: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&h=400&fit=crop',
    correctCharge: 'Possession',
    possibleOptions: ['Possession', 'Drug Trafficking', 'DUI', 'Public Intoxication', 'Disorderly Conduct', 'Paraphernalia']
  },
  {
    id: '9',
    name: 'Christopher Taylor',
    age: 37,
    imageUrl: 'https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?w=400&h=400&fit=crop',
    correctCharge: 'Burglary',
    possibleOptions: ['Burglary', 'Breaking and Entering', 'Theft', 'Robbery', 'Trespassing', 'Criminal Trespass']
  },
  {
    id: '10',
    name: 'Nicole Anderson',
    age: 29,
    imageUrl: 'https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?w=400&h=400&fit=crop',
    correctCharge: 'Disorderly Conduct',
    possibleOptions: ['Disorderly Conduct', 'Public Intoxication', 'Trespassing', 'Disturbing the Peace', 'Loitering', 'Resisting Arrest']
  }
];

// Generate mugshots with randomized options
export const mockMugshots = baseMugshots.map(mugshot => {
  // Get 3 random wrong answers from possibleOptions (excluding the correct one)
  const wrongOptions = mugshot.possibleOptions.filter(opt => opt !== mugshot.correctCharge);
  const shuffledWrong = shuffleArray(wrongOptions).slice(0, 3);
  
  // Combine correct answer with wrong answers and shuffle
  const allOptions = shuffleArray([mugshot.correctCharge, ...shuffledWrong]);
  
  return {
    id: mugshot.id,
    name: mugshot.name,
    age: mugshot.age,
    imageUrl: mugshot.imageUrl,
    correctCharge: mugshot.correctCharge,
    options: allOptions
  };
});

// JailBird Bonus Questions - Now using mugshot format
export const jailBirdBonusQuestions = [
  {
    id: 'bonus1',
    name: 'Marcus Rodriguez',
    age: 41,
    imageUrl: 'https://images.unsplash.com/photo-1570295999919-56ceb5ecca61?w=400&h=400&fit=crop',
    correctCharge: 'Wire Fraud',
    options: ['Wire Fraud', 'Embezzlement', 'Money Laundering', 'Tax Evasion']
  },
  {
    id: 'bonus2',
    name: 'Victoria Chen',
    age: 35,
    imageUrl: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=400&h=400&fit=crop',
    correctCharge: 'Conspiracy',
    options: ['Conspiracy', 'Racketeering', 'Extortion', 'Bribery']
  },
  {
    id: 'bonus3',
    name: 'James Mitchell',
    age: 52,
    imageUrl: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&h=400&fit=crop',
    correctCharge: 'Insider Trading',
    options: ['Insider Trading', 'Securities Fraud', 'Market Manipulation', 'Wire Fraud']
  },
  {
    id: 'bonus4',
    name: 'Diana Foster',
    age: 29,
    imageUrl: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400&h=400&fit=crop',
    correctCharge: 'Arson',
    options: ['Arson', 'Vandalism', 'Reckless Endangerment', 'Destruction of Property']
  },
  {
    id: 'bonus5',
    name: 'Anthony Blake',
    age: 38,
    imageUrl: 'https://images.unsplash.com/photo-1463453091185-61582044d556?w=400&h=400&fit=crop',
    correctCharge: 'Blackmail',
    options: ['Blackmail', 'Extortion', 'Harassment', 'Stalking']
  },
  {
    id: 'bonus6',
    name: 'Rachel Martinez',
    age: 44,
    imageUrl: 'https://images.unsplash.com/photo-1489424731084-a5d8b219a5bb?w=400&h=400&fit=crop',
    correctCharge: 'Perjury',
    options: ['Perjury', 'Obstruction of Justice', 'Contempt of Court', 'Witness Tampering']
  },
  {
    id: 'bonus7',
    name: 'Kenneth White',
    age: 47,
    imageUrl: 'https://images.unsplash.com/photo-1500917293891-ef795e70e1f6?w=400&h=400&fit=crop',
    correctCharge: 'Racketeering',
    options: ['Racketeering', 'Organized Crime', 'Money Laundering', 'Conspiracy']
  },
  {
    id: 'bonus8',
    name: 'Patricia Young',
    age: 33,
    imageUrl: 'https://images.unsplash.com/photo-1502378735452-bc7d86632805?w=400&h=400&fit=crop',
    correctCharge: 'Cybercrime',
    options: ['Cybercrime', 'Hacking', 'Identity Theft', 'Wire Fraud']
  }
];

// Mock leaderboard data
export const mockLeaderboard = [
  { rank: 1, nickname: 'DetectivePro', avatarId: 10, score: 9850, gamesPlayed: 150, accuracy: 95, jailBirdBonuses: 142 },
  { rank: 2, nickname: 'MugshotMaster', avatarId: 2, score: 9200, gamesPlayed: 140, accuracy: 92, jailBirdBonuses: 128 },
  { rank: 3, nickname: 'CrimeSlayer', avatarId: 17, score: 8750, gamesPlayed: 135, accuracy: 90, jailBirdBonuses: 120 },
  { rank: 4, nickname: 'LineupLegend', avatarId: 5, score: 8100, gamesPlayed: 120, accuracy: 88, jailBirdBonuses: 105 },
  { rank: 5, nickname: 'JusticeSeeker', avatarId: 18, score: 7850, gamesPlayed: 115, accuracy: 86, jailBirdBonuses: 98 },
  { rank: 6, nickname: 'GuessGenius', avatarId: 3, score: 7200, gamesPlayed: 110, accuracy: 84, jailBirdBonuses: 92 },
  { rank: 7, nickname: 'ArrestAce', avatarId: 14, score: 6900, gamesPlayed: 100, accuracy: 82, jailBirdBonuses: 85 },
  { rank: 8, nickname: 'CriminalCatcher', avatarId: 8, score: 6500, gamesPlayed: 95, accuracy: 80, jailBirdBonuses: 78 },
  { rank: 9, nickname: 'MugshotMania', avatarId: 19, score: 6100, gamesPlayed: 90, accuracy: 78, jailBirdBonuses: 71 },
  { rank: 10, nickname: 'LineupLover', avatarId: 15, score: 5800, gamesPlayed: 85, accuracy: 76, jailBirdBonuses: 65 }
];
